import { RefreshTokenException } from '@/domain/authenticating/authorization/exception/RefreshTokenException'

export class TokenExpiredException extends RefreshTokenException {

}
